import { schema } from "normalizr";
import { BrandSchemaMapRecord } from "records/schema/brand-schema-map";

export const BrandNuORDERMapSchema = new schema.Entity(
    "brandSchemaMap",
    {},
    {
        idAttribute: "brand_schema",
    }
);

(BrandNuORDERMapSchema as any).record = BrandSchemaMapRecord;
